
<linkable-item as="router-link" :to="`/showcase/${collection.uid}?collectionId=${collection.id}`">
  <div class="collection-item">
    <img v-if="collection.photoUrl" v-lazy="{ src: collection.photoUrl }" />

    <div v-else-if="collection.displayName" class="letter-wrapper">
      {{ collection.displayName[0].toUpperCase() }}
    </div>

    <div v-else class="letter-wrapper">
      <icon name="person" />
    </div>

    <div class="collection-item-content">
      <div class="collection-name">
        {{ collection.name }}
      </div>

      <p class="bottom-row">
        <span class="display-name">{{ collection.displayName }}</span>

        <stat-item
          label="Num Cards"
          :value="$filters.number(collection.totalNumCards)"
        />
      </p>
    </div>
  </div>
</linkable-item>
